export default {
  google_eventlist: state => state.google_eventlist,

  google_is_signed_in: state => state.google_is_signed_in,

  google_calendar_authorized: state => state.google_authorized,

  google_calendar_auth_date: state => state.google_auth_date,
}
